
(function() {
  function hasProgressBar(el) {
    if (!el) return false;
    if (el.querySelector('.tl-custom-cart-goal-container, .tl__cart-goal__container__drawer')) return true;
    const drawerEl = el.closest('#cart-drawer, .cart-drawer, .drawer, [role="dialog"], .ajax-cart, .mini-cart, .cart-drawer-container, form[action="/cart"]');
    if (drawerEl && drawerEl.querySelector('.tl-custom-cart-goal-container, .tl__cart-goal__container__drawer')) return true;
    if (el.previousElementSibling && (el.previousElementSibling.classList.contains('tl-custom-cart-goal-container') || el.previousElementSibling.classList.contains('tl__cart-goal__container__drawer'))) return true;
    if (el.nextElementSibling && (el.nextElementSibling.classList.contains('tl-custom-cart-goal-container') || el.nextElementSibling.classList.contains('tl__cart-goal__container__drawer'))) return true;
    return false;
  }

  function patchEmbed(embed) {
    if (embed.__custom_patched) return;
    embed.__custom_patched = true;

    const originalGetData = embed.getDataFromAjax;
    embed.getDataFromAjax = async function() {
      try {
        const cartJsResponse = await fetch("/cart.js");
        if (cartJsResponse.ok) {
          const cartData = await cartJsResponse.json();
          for (const item of cartData.items) {
            const productId = String(item.product_id);
            if (!embed.productIdMapCollection.has(productId)) {
              await embed.getVariantData(item.id);
            }
          }
        }
      } catch (e) {}

      try {
        return await originalGetData.apply(this, arguments);
      } catch (error) {
        return;
      }
    };

    let debounceTimer = null;
    const domObserver = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const widgetVisibility = embed.getWidgetVisibility ? embed.getWidgetVisibility(embed.cartGoal?.show_widget_on) : {};
        const targetMapping = {
          cartDrawer: embed.cartDrawDisplay?.selector || embed.defaultCartSelector,
          cartPage: embed.cartDisplay?.selector || embed.defaultCartSelector,
          productPage: embed.productPageDisplay?.selector || embed.defaultProductPageSelector
        };

        let needsRender = false;
        Object.keys(widgetVisibility).forEach(key => {
          if (widgetVisibility[key]) {
            const selector = targetMapping[key];
            if (selector) {
              document.querySelectorAll(selector).forEach(el => {
                if (!hasProgressBar(el)) {
                  needsRender = true;
                }
              });
            }
          }
        });

        if (needsRender) {
          try {
            embed.renderAllCartGoals();
          } catch (err) {}
        }
      }, 250);
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  const existingEmbed = window.tlCartGoalEmbed;
  if (existingEmbed) {
    patchEmbed(existingEmbed);
    if (typeof existingEmbed.updateCartTotal === 'function') {
      try {
        existingEmbed.updateCartTotal();
      } catch (err) {}
    }
  } else {
    let tempEmbed = null;
    Object.defineProperty(window, 'tlCartGoalEmbed', {
      get() { return tempEmbed; },
      set(val) {
        tempEmbed = val;
        if (tempEmbed) patchEmbed(tempEmbed);
      },
      configurable: true
    });
  }
})();
